import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  StyledStepNum,
  StyledTable,
  StyledTitle,
  StyledTd,
} from './custom-styled-components/_MyCustomSC';
import PickupDate from './PickupDate';
import { Select, Checkbox, Tooltip } from 'antd';
import { isEmpty } from '../../util/isEmpty';
import PickupDeliveryFactory from './PickupDeliveryFactory';
import ExistingFactoryDescForm from './ExistingFactoryDescForm';
import NewFactoryDescForm from './NewFactoryDescForm';
import CustomDropdownRender from '../common/CustomDropdownRender';
import { sortArrObjStr } from '../../util/sortArrObjStr';
import { chunkString } from '../../util/chunkString';
import {getInitAuth, getRemotePortsJson} from "../../actions";

const { Option } = Select;

// const dropdownArr = [
//   { name: "Port", desc: "Pickup at port warehouse, no trucking included" },
//   { name: "Factory", desc: "Industrial setting with loading dock" }
// ];

// const EXISTING_FACTORY = 'existing factory';
// const NEW_FACTORY = 'new factory';

const StyledDiv = styled.div`
  width: auto;
  min-width: 870px;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
`;
const StyledSelect = styled(Select)`
  width: 170px;
`;

const PORT = 'port';

const OPTION_STRING_CHUNK_LENGTH = 23;

/**
 * @component
 * @category Form Page
 * @subcategory Pickup
 * @name PickupForm
 * @description pickup component
 * <br> <br>
 * **Example**
 * ```js
 *   <PickupForm/>
 * ```
 */
class PickupForm extends Component {
  state = {
    selectedPortId: '',
    showCheckboxCharge: true,
  };

  /**
   * @description when pickup origin location type dropdown is selected, it is invoked
   * <br> <br>
   * **onPortChange(value) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | value         |  string       |  `port` or `factory`|

   * Returns: Type: void
   */
  onPortChange = (value) => {
    if (value === 'port') {
      this.props.getRemotePickupData();

      this.setState({
        showCheckboxCharge: true,
      });
      this.resetNewFactoryData();
    } else {
      this.props.updatePickupData({ country: '', city: '' });
      this.setState({ showCheckboxCharge: false });
    }
    this.props.updatePickupDeliveryFactoryInfo({
      type: 'pickup',
      data: {
        isExistingFactorySelected: null,
        existingFactoryListArrIndex: null,
      },
    });
    //when user select port or factory type
    this.props.updatePickupData({
      pickupType: value,
      selectedExistingFactoryJson: '',
    });
  };

  /**
   * @description when  type `port` is selected, it is invoked when
   * either a country dropdown option or a city dropdown option is selected.
   * <br> <br>
   * **onSelectChange(value, type) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | value         |  string       |  selected value e.g. `Australia` for type `country`, `{"name":"Linz","id":26}` for type `city`|
   * | type          |  string       |  dropdown type e.g. `country`, `city` |

   * Returns: Type: void
   */
  onSelectChange = (value, type) => {
    console.log(value)
    console.log(type)
    if (type === 'country') {
      this.props.updatePickupData({ country: value });
    } else {
      const cityObj = JSON.parse(value);
      this.props.updatePickupData({ city: cityObj.name, id: cityObj.id });
    }
  };

  /**
   * @description when  an existing factory or "new factory" is selected,
   * it is invoked from [PickupDeliveryFactory]{@link PickupDeliveryFactorySet} component.
   * <br> <br>
   * **onFactoryDataChange(isExistingFactory, data) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | isExistingFactory             |  boolean       |  `true` - existing factory is selected, `false` - new factory is selected |
   * | data          |  number       |  selected existing factory array index e.g. `0`, `1`, it is `null` in case of new factory |

   * Returns: Type: void
   */
  onFactoryDataChange = (isExistingFactory, data) => {
    console.log(data)
    console.log(isExistingFactory)
    if (isExistingFactory) {
      this.resetNewFactoryData();
      // this.props.isExistingFactorySelected=true
      this.props.updatePickupDeliveryFactoryInfo({
        type: 'pickup',
        data: {
          isExistingFactorySelected: true,
          existingFactoryListArrIndex: data.id, // here data is 0, 1, etc
        },
      });
    } else {
      this.props.updatePickupDeliveryFactoryInfo({
        type: 'pickup',
        data: {
          isExistingFactorySelected: false,
          existingFactoryListArrIndex: data, // here data is 'null'
        },
      });
      this.props.updatePickupData({
        selectedExistingFactoryJson: '',
      });
    }
    // this.updateExistingFactoryMissingPort('');
  };

  /**
   * @description when a port in new factory is selected, this is invoked
   * <br> <br>
   * **handleSelectExistingNewPort(e) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | e             |  string       |  selected port obj string in new factory |

   * Returns: Type: void
   */
  handleSelectExistingNewPort = (e) => {
    const { isExistingFactorySelected } = this.props;
    // console.log(e.key);
    if (isExistingFactorySelected) {
      // console.log('updateExistingFactoryMissingPort:', e.key);
      // this.updateExistingFactoryMissingPort(JSON.parse(e.key));
    } else {
      const obj = JSON.parse(e); // e is the selected port obj in new factory
      // const data = `${obj.name}, ${obj.country} `;
      // this.handleNewFactoryInfoChange([PORT], data);
      this.handleNewFactoryInfoChange([PORT], obj);
    }
  };

  /**
   * @description when new factory description form data changes, this is invoked
   * <br> <br>
   * **handleNewFactoryInfoChange(type, value) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | type          | object or string or array      |  new factory description data e.g. `city`, `["port"]`, `busines_type` |
   * | value         | object or string       |  entered new factory description form value e.g. `delhi`, `{id: 122323, country: "Bangladesh", name:"Mongla"}` |

   * Returns: Type: void
   */
  handleNewFactoryInfoChange = (type, value) => {
    this.updateNewFactoryData({ [type]: value });
  };


  /**
   * @description update new factory info in redux store
   * <br> <br>
   * **updateNewFactoryData(info) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | info          | object        |  entered new factory description form data |

   * Returns: Type: void
   */
  updateNewFactoryData = (info) => {
    const { newFactoryInfo } = this.props;
    this.props.updatePickupDeliveryFactoryInfo({
      type: 'pickup',
      data: {
        newFactory: { ...newFactoryInfo, ...info },
      },
    });
  };

  /**
   * @description when `port` or existing factory is selected, then new factory data is reset.
   * <br> <br>
   * **resetNewFactoryData() -> {void}**
   * <br><br>
   * Returns: Type: void
   */
  resetNewFactoryData = () => {
    const newFactoryInfo = {
      newFactory: {
        address: '',
        city: '',
        country: '',
        postal: '',
        name: '',
        email: '',
        port: {},
      },
    };
    this.props.updatePickupDeliveryFactoryInfo({
      type: 'pickup',
      data: {
        ...newFactoryInfo,
      },
    });
  };

  render()
  {
    const { showCheckboxCharge } = this.state;
    const {  country, pickupType, isOriginChargeIncluded } =
      this.props.pickup;
    const pickupJson=this.props.portsJSON
    const showFactory = pickupType === 'factory';
    //when user select port not factory , then country, city
    const selectedCity = this.props.pickup.city;
    const selectedCountry = country;

    let countries;
    let cities;

    let countriesSet = new Set();
    !isEmpty(pickupJson) && !isEmpty(pickupJson.Ports) && pickupJson.Ports.map((port) => countriesSet.add(port.Country));
    countries = Array.from(countriesSet);
    countries = sortArrObjStr(countries);

    let citiesSet = new Set();
    !isEmpty(pickupJson) &&
      !isEmpty(pickupJson.Ports) &&
      pickupJson.Ports.map(
        (port) =>
          port.Country === selectedCountry &&
          citiesSet.add({ name: port.Name, id: port.id })
      );
    cities = Array.from(citiesSet);
    cities = sortArrObjStr(cities, undefined, 'name');

    // for factory / business

    // for empty port object in a single factory json dropdown menu
    //if port object is empty get ports from origin, destination search bar page
    //process json
    // portsJson for empty port object and new factory port object
    const { portsJSON, missingPort } = this.props;
    let tempCountriesSet = new Set();
    !isEmpty(portsJSON) &&
      !isEmpty(portsJSON.Ports) &&
      portsJSON.Ports.map((port) => tempCountriesSet.add(port.Country));

    let myCountries = Array.from(tempCountriesSet);

    //for existing factory
    const { existingFactoryJson, existingFactoryListArrIndex } = this.props;

    const { isExistingFactorySelected, selectedExistingFactoryJson } =
      this.props;



    const selectedFactoryJson = selectedExistingFactoryJson;

    const selectedFactoryInfo = selectedFactoryJson && !isEmpty(selectedFactoryJson) && (
        <ExistingFactoryDescForm
          portsJSON={portsJSON || {}}
          myCountries={myCountries}
          selectedFactoryJson={selectedFactoryJson}
          // missingPort={missingPort}
          handleSelectExistingNewPort={this.handleSelectExistingNewPort}
          isPickupMode={true}
        />
      );

    //for new factory
    //get ports from origin, destination search bar page, it's on overlay menu
    const { newFactoryInfo } = this.props;
    // console.log('newFactoryInfo port', newFactoryInfo.port);


    const enterNewFactoryInfo = !isExistingFactorySelected && (
      <NewFactoryDescForm
        portsJSON={portsJSON || {}}
        myCountries={myCountries}
        handleNewFactoryInfoChange={this.handleNewFactoryInfoChange}
        newFactoryInfo={newFactoryInfo}
        handleSelectExistingNewPort={this.handleSelectExistingNewPort}
        isPickupMode={true}
      />
    );

    return (
      <StyledDiv className="pickup-form">
        <StyledTable style={{ width: '641px', marginRight: '15px' }}>
          <tbody>
            <tr>
              <th>
                <StyledStepNum>2</StyledStepNum>
                <span style={{ fontWeight: 600 }}> Pickup goods from</span>
              </th>
            </tr>
            <tr>
              <StyledTd
                style={{
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  justifyContent: 'space-around',
                }}
              >
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'start',
                    alignItems: 'flex-start',
                  }}
                  className="testR1"
                >
                  <span className="my-form-custom-select">
                    <StyledTitle>Origin location type</StyledTitle>
                    <StyledSelect
                      placeholder="Select.."
                      onChange={this.onPortChange}
                      // className="my-select20"
                      value={pickupType || undefined}
                    >
                      <Option
                        key="port"
                        value="port"
                        label="Port(FOB)"
                        style={{ height: '85px' }}
                      >
                        <Tooltip
                          placement="right"
                          autoAdjustOverflow
                          title="Pickup at port warehouse, no trucking included"
                        >
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              width: '100%',
                            }}
                          >
                            <span style={{ color: '#333333' }}>Port(FOB)</span>

                            {chunkString(
                              'Pickup at port warehouse, no trucking included',
                              OPTION_STRING_CHUNK_LENGTH
                            ).map((str, index) => (
                              <span
                                key={index}
                                className="option-desc"
                                style={{
                                  fontSize: '11px',
                                  color: '#8DABC4',
                                }}
                              >
                                {str}
                              </span>
                            ))}

                          </div>
                        </Tooltip>
                      </Option>

                      <Option
                        key="factory"
                        value="factory"
                        label="Factory"
                        style={{ height: '85px' }}
                      >
                        <Tooltip
                          placement="right"
                          autoAdjustOverflow
                          title="Industrial setting with loading dock"
                        >
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              width: '100%',
                            }}
                          >
                            <span style={{ color: '#333333' }}>
                              Business/Factory
                            </span>
                            {chunkString(
                              'Industrial setting with loading dock',
                              OPTION_STRING_CHUNK_LENGTH
                            ).map((str, index) => (
                              <span
                                key={index}
                                className="option-desc"
                                style={{
                                  fontSize: '11px',
                                  color: '#8DABC4',
                                }}
                              >
                                {str}
                              </span>
                            ))}
                          </div>
                        </Tooltip>
                      </Option>
                    </StyledSelect>
                  </span>

                  {showFactory ? (
                    <div style={{padding: '1rem 0px'}} >
                    <PickupDeliveryFactory
                      onFactoryDataChange={this.onFactoryDataChange}
                      isPickupFactory={true}
                      mode={'pickup'}
                    />
                    </div>

                  ) : (
                    // port country, city selection
                    <span
                      style={{
                        flex: '1',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-around',
                        alignItems: 'flex-start',
                      }}
                      className="testO1"
                    >
                      <span className="testO1" style={{ width: '100%' }}></span>
                      <span>
                        <StyledTitle>Origin country</StyledTitle>

                        <StyledSelect
                          placeholder="Select country"
                          onChange={(value) =>
                            this.onSelectChange(value, 'country')
                          }
                          value={selectedCountry || undefined}
                          dropdownRender={(menu) => (
                            <div>
                              {pickupType && !isEmpty(pickupJson) ? (
                                menu
                              ) : (
                                <CustomDropdownRender
                                  text={
                                    !pickupType && 'select location type first'
                                  }
                                  showSpin={!!pickupType}
                                />
                              )}
                            </div>
                          )}
                        >
                          {countries.map((Country, index) => (
                            <Option
                              value={Country}
                              key={`${Country}, ${index}`}
                            >
                              {Country}
                            </Option>
                          ))}
                        </StyledSelect>
                      </span>
                      <span className="testO1" style={{ width: '100%' }}></span>
                      <span>
                        <StyledTitle>City </StyledTitle>

                        <StyledSelect
                          placeholder="Select city"
                          onChange={(value) =>
                            this.onSelectChange(value, 'city')
                          }
                          value={selectedCity || undefined}
                          dropdownRender={(menu) => (
                            <div>
                              {cities.length !== 0 ? (
                                menu
                              ) : (
                                <CustomDropdownRender text="select country first" />
                              )}
                            </div>
                          )}
                        >
                          {cities.map((port, index) => (
                            <Option
                              value={JSON.stringify(port)}
                              key={`${port.name}, ${index}`}
                            >
                              {port.name}
                            </Option>
                          ))}
                        </StyledSelect>
                      </span>
                      <span className="testO1" style={{ width: '100%' }}></span>
                    </span>
                  )}
                </div>

                 {/*existing factory*/}
                {existingFactoryListArrIndex !== null && selectedFactoryInfo }
                 {/*new factory*/}
                {isExistingFactorySelected !== null &&
                  isExistingFactorySelected === false &&
                  enterNewFactoryInfo     }

                {/* checkbox */}
                {showCheckboxCharge && (
                  <div
                    style={{
                      paddingTop: '4px',
                      fontSize: '13px',
                    }}
                    className="testR1"
                  >
                    <Checkbox
                      style={{ marginRight: '4px' }}
                      checked={
                        isOriginChargeIncluded ? isOriginChargeIncluded : false
                      }
                      onChange={(e) => {
                        this.props.updatePickupData({
                          isOriginChargeIncluded: e.target.checked,
                        });
                      }}
                    />
                    <span style={{ color: '#373848' }}>
                      Origin Charges included
                    </span>
                  </div>
                )}
              </StyledTd>
            </tr>
          </tbody>
        </StyledTable>
        <PickupDate />
      </StyledDiv>
    );
  }
}

PickupForm.propTypes = {
  /**
   * pickup section data
   */
  pickup: PropTypes.object,
  /**
   * pickup existing factory json
   */
  existingFactoryJson: PropTypes.object,
  /**
   * origin ports json on search page
   */
  portsJSON: PropTypes.object,

  /**
   *  new pickup factory data
   */
  newFactoryInfo: PropTypes.object,
  /**
   * pickup factory info
   */
  pickupFactoryInfo: PropTypes.object,
  /**
   * array index (starts from zero) of selected existing factory in the list of factories
   * it also accepts `null`
   */
  existingFactoryListArrIndex: PropTypes.number,
  /**
   * whether existing factory is selected. it also accepts `null`
   */
  isExistingFactorySelected: PropTypes.bool,
  /**
   * selected Existing Factory for pickup on factory mode
   */
  selectedExistingFactoryJson: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    pickup: state.form.pickup,

    existingFactoryJson: state.form.pickup.existingFactoryJson,
    portsJSON: state.route.originPortJSON,
    destination_Json:state.route.destinationPortJSON,
    // portsJSON: state.cache.searchOriginPortsData.data,
    // missingPort: state.form.factoryInfo.pickup.existingMissingPort,
    newFactoryInfo: state.form.factoryInfo.pickup.newFactory,

    pickupFactoryInfo: state.form.factoryInfo.pickup,
    existingFactoryListArrIndex:
      state.form.factoryInfo.pickup.existingFactoryListArrIndex,

    isExistingFactorySelected:
      state.form.factoryInfo.pickup.isExistingFactorySelected,

    selectedExistingFactoryJson: state.form.pickup.selectedExistingFactoryJson,
  };
};

export default connect(mapStateToProps, actions)(PickupForm);
